"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoizedSidebarSection = exports.SidebarSection = void 0;
const react_1 = __importDefault(require("react"));
const sidebar_section_styles_1 = require("./sidebar-section.styles");
const SidebarSection = ({ title, children, className }) => (react_1.default.createElement("div", { className: className }, react_1.default.createElement(sidebar_section_styles_1.StyledHeader, null, title), children));
exports.SidebarSection = SidebarSection;
exports.MemoizedSidebarSection = react_1.default.memo(exports.SidebarSection);
exports.default = exports.MemoizedSidebarSection;
